import Signup from './Signup'

export default Signup



// WEBPACK FOOTER //
// ./src/components/Signup/index.js